import { useState } from "react";
import { toast } from "sonner";
import { publicApi } from "@/lib/api";
import { Facebook } from "lucide-react";

const FB_URL = "https://www.facebook.com/cka22";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [submitting, setSubmitting] = useState(false);

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) { toast.error("Fill required fields"); return; }
    try {
      setSubmitting(true);
      await publicApi.submitContact(form);
      toast.success("Message sent!");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch { toast.error("Try again"); }
    finally { setSubmitting(false); }
  };

  return (
    <div data-testid="page-contact" className="max-w-[1200px] mx-auto px-5 md:px-10 py-16 grid grid-cols-1 md:grid-cols-12 gap-12">
      <div className="md:col-span-5">
        <p className="overline mb-3">Say hi</p>
        <h1 className="font-display text-5xl md:text-7xl leading-none mb-6">Get in touch.</h1>
        <p className="text-white/70 leading-relaxed mb-8">Questions about a piece, wholesale, collabs or events — drop us a line.</p>
        <div className="space-y-3 text-white/70">
          <p><span className="overline block">Email</span> hello@camskooriart.com</p>
          <p><span className="overline block">Based</span> Australia · shipping worldwide</p>
          <div>
            <span className="overline block mb-2">Follow the studio</span>
            <a
              href={FB_URL}
              target="_blank"
              rel="noreferrer"
              data-testid="contact-facebook"
              className="inline-flex items-center gap-2 border border-white/20 px-4 py-2 text-sm uppercase tracking-widest hover:bg-[#FF4500] hover:border-[#FF4500] hover:text-white transition-colors"
            >
              <Facebook className="w-4 h-4" /> Facebook · @cka22
            </a>
          </div>
        </div>
      </div>
      <form onSubmit={onSubmit} className="md:col-span-7 grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="overline block mb-2">Name*</label>
          <input data-testid="contact-input-name" required className="cka-input" value={form.name} onChange={update("name")} />
        </div>
        <div>
          <label className="overline block mb-2">Email*</label>
          <input data-testid="contact-input-email" type="email" required className="cka-input" value={form.email} onChange={update("email")} />
        </div>
        <div className="md:col-span-2">
          <label className="overline block mb-2">Subject</label>
          <input data-testid="contact-input-subject" className="cka-input" value={form.subject} onChange={update("subject")} />
        </div>
        <div className="md:col-span-2">
          <label className="overline block mb-2">Message*</label>
          <textarea data-testid="contact-input-message" required rows={7} className="cka-input" value={form.message} onChange={update("message")} />
        </div>
        <div className="md:col-span-2">
          <button data-testid="contact-submit" disabled={submitting} className="btn-primary disabled:opacity-50">{submitting ? "Sending..." : "Send Message"}</button>
        </div>
      </form>
    </div>
  );
}
